export default (line: string) => /^\/\//.test(line.trim());
